import dynamic from "next/dynamic";
import Markdown from "markdown-to-jsx";
import { SelfServePageData } from "../fetcher";
import Balancer from "react-wrap-balancer";
import type { SubscriptionLevel } from "lib/types";

const Cta = dynamic(() => import("./cta"), {
  ssr: false,
});

type FooterCtaProps = {
  data: SelfServePageData;
  readerSubscriptionLevel: SubscriptionLevel;
  onButtonClick: () => void;
};

export const FooterCta = ({
  data,
  readerSubscriptionLevel,
  onButtonClick,
}: FooterCtaProps) => {
  return (
    <div className="flex w-full flex-col items-center gap-y-[30px] bg-[#E1E5FA] px-6 py-10 md:py-[70px] lg:py-[90px]">
      <p className="text-center font-recklessBold text-[32px] leading-[130%] md:text-[52px] [&_strong]:text-pro-blue">
        <Balancer>
          <Markdown>{data.footerCtaHeading}</Markdown>
        </Balancer>
      </p>
      <Cta
        data={data}
        readerSubscriptionLevel={readerSubscriptionLevel}
        onButtonClick={onButtonClick}
      />
    </div>
  );
};
